module.exports = __webpack_public_path__ + "static/media/dropdown.d8395579.svg";